import { RouteProp } from '@react-navigation/native';
import React from 'react';
import { ProfilesTabParamList, useGoBack } from '../../../../../utils/appNavigationNames';
import { AnimateLoadedContent } from '../../../../v2BaseComponents/Loader';
import { ActionButtonLayout } from '../../../../v2BaseComponents/ActionButtonLayout';
import { getIntl } from '../../../../../utils/intl';
import CopyOrganizationCareTeamMembersToClients, {
    useCopyOrganizationCareTeamMemberToClientsState,
} from '../../../../shared/ClientRecord/CopyOrganizationCareTeamMembersToClients';

const intl = getIntl('copy-organization-care-team-member-screen', {
    cancel: 'Cancel',
    share: 'Share',
});

export type CopyOrgCareTeamMemberToClientsScreenOwnProps = {};

export type CopyOrgCareTeamMemberToClientsScreenProps = CopyOrgCareTeamMemberToClientsScreenOwnProps & {
    route: RouteProp<ProfilesTabParamList, 'copy-org-care-team-member-to-clients'>;
};

const CopyOrgCareTeamMemberToClientsScreen: React.FC<CopyOrgCareTeamMemberToClientsScreenProps> = ({ route }) => {
    const goBack = useGoBack();
    const {
        isInitializing,
        isSubmitting,
        onSelectedCareTeamMemberId,
        selectedCareTeamMembers,
        careTeamSelectOptions,
        onSubmit,
        canSubmit,
        selectedCareTeamMemberIds,
    } = useCopyOrganizationCareTeamMemberToClientsState({
        onClose: goBack,
        destinationMedicalProfileIds: route.params.medicalProfileIds,
    });

    const isLoading = isInitializing || isSubmitting;
    return (
        <AnimateLoadedContent isLoading={isLoading}>
            {() => (
                <ActionButtonLayout
                    actions={[
                        {
                            title: intl('cancel'),
                            variant: 'secondary',
                            onPress: goBack,
                            isDisabled: isLoading,
                            testID: 'form-submit-cancel',
                            icon: 'XCircle',
                        },
                        {
                            title: `${intl('share')}${
                                selectedCareTeamMemberIds.length ? ` (${selectedCareTeamMemberIds.length})` : ''
                            }`,
                            variant: 'primary',
                            onPress: onSubmit,
                            isDisabled: !canSubmit || isLoading,
                            testID: 'form-submit-button',
                            icon: 'Share2',
                        },
                    ]}
                >
                    <CopyOrganizationCareTeamMembersToClients
                        careTeamSelectOptions={careTeamSelectOptions}
                        selectedCareTeamMemberIds={selectedCareTeamMemberIds}
                        selectedCareTeamMembers={selectedCareTeamMembers}
                        onSelectedCareTeamMemberId={onSelectedCareTeamMemberId}
                        destinationMedicalProfileIds={route.params.medicalProfileIds}
                        isDisabled={isSubmitting}
                    />
                </ActionButtonLayout>
            )}
        </AnimateLoadedContent>
    );
};

export default React.memo(CopyOrgCareTeamMemberToClientsScreen);
